import { useIsFetching, useIsMutating } from '@tanstack/react-query';

import { useLoadingStore } from '~/store';

/**
 * 전역 로딩 상태를 통합 관리하는 훅
 *
 * - React Query의 isFetching/isMutating과 수동 loadingCount를 통합
 * - meta.showGlobalLoading: false 인 쿼리는 전역 로딩에서 제외
 * - meta.showGlobalDimOverlay: false 인 쿼리가 있으면 dim 오버레이 적용 안함
 */
const useGlobalLoading = () => {
  const isFetching = useIsFetching({
    predicate: (query) => query.meta?.showGlobalLoading !== false,
  });
  const isMutating = useIsMutating({
    predicate: (mutation) => mutation.meta?.showGlobalLoading !== false,
  });

  const isFetchingNonDimmed = useIsFetching({
    predicate: (query) => query.meta?.showGlobalLoading !== false && query.meta?.showGlobalDimOverlay === false,
  });
  const isMutatingNonDimmed = useIsMutating({
    predicate: (mutation) =>
      mutation.meta?.showGlobalLoading !== false && mutation.meta?.showGlobalDimOverlay === false,
  });

  const { loadingCount, dimmed: storeDimmed } = useLoadingStore();

  /** @TODO React Query 전환 후 loadingCount 제거 */
  const isLoading = isFetching > 0 || isMutating > 0 || loadingCount > 0;

  const dimmed = isFetchingNonDimmed > 0 || isMutatingNonDimmed > 0 ? false : storeDimmed;

  return { isLoading, dimmed };
};

export default useGlobalLoading;
